import { render, staticRenderFns } from "./SubsidioParalizacion.vue?vue&type=template&id=e13f8d66&scoped=true&"
import script from "./SubsidioParalizacion.vue?vue&type=script&lang=js&"
export * from "./SubsidioParalizacion.vue?vue&type=script&lang=js&"
import style0 from "./SubsidioParalizacion.vue?vue&type=style&index=0&id=e13f8d66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e13f8d66",
  null
  
)

export default component.exports